export const colors = ['#2E93fA', '#66DA26', '#546E7A', '#E91E63', '#FF9800'];
export const colorsNegative = ['#D9534F', '#ad346b', '#cf21c0', '#8f21cf', '#3710b5'];

export const colorsFn = colors.map((hex: string, index: number) => ((value: { value: number; seriesIndex: number; w: any }) => { if (value.value > 0) return hex; return colorsNegative[index]; }));

export const magicUniqueColor = [
  '#fc77f8',
  '#ad346b',
  '#0ccf2d',
  '#cf21c0',
  '#0cc8cf',
  '#e87800',
  '#b31515',
  '#21ffb5',
  '#de00b9',
  '#e0ce00',
  '#8300ab',
  '#66DA26',
  '#D9534F',
  '#000ead',
  '#ad4800',
  '#fff700',
  '#2E93fA',
  '#546E7A',
  '#E91E63',
  '#8cff00',
  '#8f21cf',
  '#FF9800',
  '#3710b5',
];

export const pieChartColors = [
  '#F36D27',
  '#6B0784',
  '#AD5100',
  '#FDD343',
  '#FBEECA',
  '#B3B5BD',
  '#009E4B',
  '#241C15',
];
